"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultiSelectionButtons = exports.SingleSelectionButtons = exports.SelectionButton = void 0;
var react_1 = __importDefault(require("react"));
var material_1 = require("@mui/material");
var system_1 = require("@mui/system");
var prism_icons_1 = require("@octanner/prism-icons");
var colors_1 = require("../ThemeProvider/colors");
var pulseInOut = (0, system_1.keyframes)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    0% {\n      opacity: 0;\n    }\n    50% {\n      opacity: 1;\n    },\n    100% {\n      opacity: 0;\n    }\n  "], ["\n    0% {\n      opacity: 0;\n    }\n    50% {\n      opacity: 1;\n    },\n    100% {\n      opacity: 0;\n    }\n  "])));
var Group = (0, material_1.styled)('div')({
    display: 'flex',
    flexWrap: 'wrap',
});
var CheckWrap = (0, material_1.styled)('span')({
    alignItems: 'center',
    display: 'flex',
    marginLeft: -8,
    marginRight: 8,
});
var BaseButton = (0, material_1.styled)('button')({
    alignItems: 'center',
    backgroundColor: '#fff',
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: colors_1.tannerGray['500'],
    borderRadius: 3,
    display: 'flex',
    justifyContent: 'center',
    fontSize: 14,
    outline: 'none',
    overflow: 'visible',
    padding: '8px 16px',
    position: 'relative',
    transition: 'all 200ms',
    '&:hover, &:focus': {
        borderColor: colors_1.tannerGray['900'],
        boxShadow: "0px 0px 0px 2px ".concat(colors_1.tannerGray['900'], "33"),
    },
    '&::after': {
        content: "''",
        position: 'absolute',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        borderRadius: 3,
        opacity: 0,
        boxShadow: "0px 0px 0px 4px ".concat(colors_1.tannerGray['900'], "33"),
    },
    '&:not(:first-of-type)': {
        marginLeft: 8,
    },
    '&[aria-checked="true"]': {
        borderColor: colors_1.tannerSemantic['info'].color,
        color: colors_1.tannerSemantic['info'].color,
        '&::after': {
            boxShadow: "0px 0px 0px 4px ".concat(colors_1.tannerSemantic['info'].color, "33"),
        },
        '&:hover, &:focus': {
            boxShadow: "0px 0px 0px 2px ".concat(colors_1.tannerSemantic['info'].color, "33"),
        },
    },
    '&[disabled]': {
        color: colors_1.tannerGray['400'],
        backgroundColor: colors_1.tannerGray['50'],
        borderColor: colors_1.tannerGray['400'],
        boxShadow: 'none',
    },
});
var SelectionButton = react_1.default.forwardRef(function (_a, ref) {
    var children = _a.children, isCheckButton = _a.isCheckButton, props = __rest(_a, ["children", "isCheckButton"]);
    return (react_1.default.createElement(BaseButton, __assign({}, props, { sx: __assign({ '&:focus::after': {
                animation: "".concat(pulseInOut, " 1000ms ease-in infinite"),
            } }, props.sx), ref: ref }),
        isCheckButton && (react_1.default.createElement(CheckWrap, null, props['aria-checked'] ? react_1.default.createElement(prism_icons_1.Check, null) : react_1.default.createElement(prism_icons_1.Checkbox, null))),
        children));
});
exports.SelectionButton = SelectionButton;
var SingleSelectionButtons = function (_a) {
    var children = _a.children, onChange = _a.onChange, value = _a.value, props = __rest(_a, ["children", "onChange", "value"]);
    var childArray = react_1.default.Children.toArray(children);
    var _b = __read(react_1.default.useState(false), 2), focus = _b[0], setFocus = _b[1];
    var _c = __read(react_1.default.useState(value || ''), 2), selected = _c[0], setSelected = _c[1];
    var toggleItem = function (item) {
        var isAlreadySelected = value === item;
        var updatedValue = isAlreadySelected ? value : item;
        setSelected(item);
        onChange === null || onChange === void 0 ? void 0 : onChange(updatedValue);
    };
    var switchRadioKey = function (e, index) {
        var currIndex = index;
        var newItem = null;
        switch (e.key) {
            case 'Up':
            case 'ArrowUp':
            case 'Left':
            case 'ArrowLeft':
                while (!react_1.default.isValidElement(newItem) || newItem.props.disabled) {
                    if (currIndex === 0) {
                        currIndex = childArray.length - 1;
                    }
                    else {
                        currIndex = currIndex - 1;
                    }
                    newItem = childArray[currIndex];
                }
                break;
            case 'Down':
            case 'ArrowDown':
            case 'Right':
            case 'ArrowRight':
                while (!react_1.default.isValidElement(newItem) || newItem.props.disabled) {
                    if (currIndex === childArray.length - 1) {
                        currIndex = 0;
                    }
                    else {
                        currIndex = currIndex + 1;
                    }
                    newItem = childArray[currIndex];
                }
                break;
            default:
                return;
        }
        e.preventDefault();
        setFocus(true);
        setSelected(newItem.props.value);
    };
    return (react_1.default.createElement(Group, __assign({ role: "radiogroup" }, props), childArray.map(function (child, index) {
        if (react_1.default.isValidElement(child)) {
            var isSelected_1 = selected === child.props.value || false;
            return react_1.default.cloneElement(child, {
                // TODO figure out a way to remove this ts-ignore
                // @ts-ignore this is a button and does have 'aria-checked' available
                'aria-checked': isSelected_1,
                onClick: function () { return toggleItem(child.props.value); },
                onKeyDown: function (e) { return switchRadioKey(e, index); },
                ref: function (button) {
                    if (isSelected_1 && focus) {
                        setFocus(false);
                        button === null || button === void 0 ? void 0 : button.focus();
                    }
                },
                role: 'radio',
                tabIndex: isSelected_1 ? 0 : -1,
            });
        }
        return child;
    })));
};
exports.SingleSelectionButtons = SingleSelectionButtons;
var MultiSelectionButtons = function (_a) {
    var children = _a.children, onChange = _a.onChange, value = _a.value, props = __rest(_a, ["children", "onChange", "value"]);
    var childArray = react_1.default.Children.toArray(children);
    var toggleItem = function (item) {
        var isAlreadySelected = value === null || value === void 0 ? void 0 : value.some(function (selected) { return selected === item; });
        var updatedValue = isAlreadySelected
            ? (value || []).filter(function (selected) { return selected !== item; })
            : __spreadArray(__spreadArray([], __read((value || [])), false), [item], false);
        onChange === null || onChange === void 0 ? void 0 : onChange(updatedValue);
    };
    var checkKey = function (e, value) {
        if (e.key === 'Space') {
            e.preventDefault();
            toggleItem(value);
        }
    };
    return (react_1.default.createElement(Group, __assign({}, props), childArray.map(function (child) {
        if (react_1.default.isValidElement(child)) {
            var isSelected = (value === null || value === void 0 ? void 0 : value.some(function (item) { return item === child.props.value; })) || false;
            return react_1.default.cloneElement(child, {
                // TODO figure out a way to remove this ts-ignore
                // @ts-ignore this is a button and does have 'aria-checked' available
                'aria-checked': isSelected,
                isCheckButton: true,
                onClick: function () { return toggleItem(child.props.value); },
                onKeyDown: function (e) {
                    return checkKey(e, child.props.value);
                },
                role: 'checkbox',
            });
        }
        return child;
    })));
};
exports.MultiSelectionButtons = MultiSelectionButtons;
var templateObject_1;
//# sourceMappingURL=index.js.map